export const underwriteDealConstants = {
  SET_PROSPECT_URL: 'SET_PROSPECT_URL',
}
